// file path: src\Types\project-task.type.ts

import { ReactNode } from "react";
import Pagination from "./pagination.type";
import Project from "./project.type";
import User from "./user.type";

export type TaskStatus = 'Not Started' | 'In Progress' | 'In Review' | 'Completed'

// Define the TypeScript interface for a Task
export interface SubTask {
    project_id: number;
    task_id: number;
    sub_task_id: number;
    task: string;
    description?: string;
    section?: string;
    archived?: boolean;
    hours_allotted?: number;
    hours_tracked?: number;
    assignee_id?: number;
    due_date?: string;
    status: TaskStatus;
    start_date?: string;
    created_at?: string;
    updated_at?: string;

    // for specially task table
    groupIndex?: number
    groupTaskIndex?: number
    taskIndex?: number
    groupSubTaskIndex?: number
    subTaskIndex?: number
    position: number
    comments_count: number
    notInserted?: boolean // if task was not saved in server
}
// Define the TypeScript interface for a Task
interface Task extends SubTask {
    checked?: boolean;
    sub_tasks: SubTask[]; // Consider refining this with a more specific type if sub_tasks have a consistent structure
    comments?: any[];
}
export type TaskRow = Omit<Task, 'sub_tasks'> & {
    sub_task_count: number;
    project: Project
    sub_client?: string
    assignee?: User
}
export type TaskRespponse = SubTask & {
    hours_allotted: string;
    hours_tracked: string;
}
export enum TaskColumn {
    Task = 'task',
    AssigneeID = 'assignee_id',
    Status = 'status',
    DueDate = 'due_date',
    HoursAllotted = 'hours_allotted',
    HoursTracked = 'hours_tracked'
}


export enum SortColumn {
    Task = TaskColumn.Task,
    AssigneeID = TaskColumn.AssigneeID,
    Status = TaskColumn.Status,
    DueDate = TaskColumn.DueDate,
    HoursAllotted = TaskColumn.HoursAllotted,
    HoursTracked = TaskColumn.HoursTracked,
    Position = 'position'
}

export enum GroupByColumn {
    Task = TaskColumn.Task,
    AssigneeID = TaskColumn.AssigneeID,
    Status = TaskColumn.Status,
    DueDate = TaskColumn.DueDate,
    HoursAllotted = TaskColumn.HoursAllotted,
    HoursTracked = TaskColumn.HoursTracked,
    Section = 'section'
}
export type GroupByOption = {
    key: GroupByColumn
    label: string;
    icon?: React.ReactNode
}


export enum TaskKey {
    Task = TaskColumn.Task,
    Section = 'section',
    Position = SortColumn.Position,
    Status = TaskColumn.Status,
    Description = 'description',
    AssigneeID = TaskColumn.AssigneeID,
    Archived = 'archived',
    DueDate = TaskColumn.DueDate,
    StartDate = 'start_date'
}

export type SortCondition = {
    column: SortColumn;
    order: 'asc' | "desc";
}
export type TaskGroupAttributes = {
    [key in GroupByColumn]?: string
} & {
    section_id?: number  // Section ID for updating section names
}
export type TaskGroup = {
    attributes: TaskGroupAttributes
    tasks: Task[];
}

export interface ColumnCellProps {
    value: string;
    task?: Task;
    subTask?: SubTask;
    column: Column;
    groupIndex?: number;
    taskIndex: number;
    subTaskIndex?: number;
}

export interface Column {
    accessor: TaskColumn;
    Header: ReactNode | string
    OptionLabel: string     // used for Project Table Toolbar > GroupByOverlay
    width: number
    Cell: React.FC<ColumnCellProps>
    className: string
}

export interface TaskAttachment {
  file_name: string;
  project_id: number;
  task_id: number;
  document_id: number;
}
export type GroupByPositions = { [groupKey: string]: number };
export type moveTaskGroup = (fromIndex: number, toIndex: number) => void;
export default Task